import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProfileState {
  user: string;
  error: string;
  success: boolean;
}

const initialState: ProfileState = {
  user: "",
  error: "",
  success: false
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile(state: ProfileState, action: PayloadAction<string>) {
      state.user = action.payload;
    },
    profileSuccess(state: ProfileState, action: PayloadAction<string>) {
      state.user = action.payload;
      localStorage.setItem('authUser', JSON.stringify(state.user));
      state.success = true;
    },
    profileFailed(state: ProfileState, action: PayloadAction<string | any>) {
      state.error = action.payload;
      state.success = false;
    }
  }
})

export const { profileSuccess, profileFailed, setProfile } = profileSlice.actions;
export default profileSlice.reducer;